import { useMemo } from 'react';

import { useTokensStore } from '@app-velocity/request-gateway';

import { DiscussionContent } from './components/DiscussionContent';
import { useDiscussionContext } from './hooks/useDiscussionContext';
import { DiscussionProps } from './types';

export type { DiscussionProps } from './types';

export const Discussion = ({
  challenge,
  takenAction,
  element,
  explanation,
  hidden = false,
}: DiscussionProps) => {
  const { accessToken } = useTokensStore();
  const { isReady } = useDiscussionContext();
  const isAuthorized = useMemo(() => !!accessToken, [accessToken]);

  if (hidden || !isAuthorized || !isReady) {
    return null;
  }

  return (
    <DiscussionContent
      challenge={challenge}
      takenAction={takenAction}
      element={element}
      explanation={explanation}
    />
  );
};
